module.exports = __webpack_public_path__ + "img/minus_btn.282bb2aa.png";